import {setActiveNavigationTab} from '@github-ui/global-navigation'
import {useMatches} from '@github-ui/react-router'
import {useEffect} from 'react'

import type {RepoRouteHandle} from './repo-route-handle'

/**
 * Keep the global navigation's highlighted tab in sync while soft-navigating inside the repo app.
 *
 * The repo app navigates via React Router, so there is no `turbo:load` and the server never
 * rewrites `<meta name="selected-link">` — the two signals `LocalNavigation` normally relies on.
 * Instead we read the `selectedLink` off the deepest matched route's handle (stamped by
 * `withRepoRouteHandle`) and push it to the global navigation imperatively (like breadcrumbs).
 */
export function useSyncActiveNavTab(): void {
  const matches = useMatches()

  // The deepest matched route with a selectedLink handle wins (most specific).
  let selectedLink: string | undefined
  for (const match of matches) {
    const handleLink = (match.handle as RepoRouteHandle | undefined)?.selectedLink
    if (handleLink !== undefined) {
      selectedLink = handleLink
    }
  }

  useEffect(() => {
    if (selectedLink) {
      setActiveNavigationTab(selectedLink)
    }
  }, [selectedLink])
}
